import { useMutation } from '@ztechapps/common.hook'
import type { UnitOfMeasureAddFormValues } from './Context'
import { unitOfMeasureQueries } from '@ztechapps/product.common'

export const useUnitOfMeasureAdd = () => {
  const [onAdd] = useMutation({
    ...unitOfMeasureQueries.createConfig,
    options: {
      mutationOptions: {
        refetchQueries: unitOfMeasureQueries.createConfig.refetchQueries,
      },
    },
  })

  const onSubmit = async (values: UnitOfMeasureAddFormValues): Promise<void> => {
    const category = typeof values.category === 'string' ? values.category : values.category?.value
    const status = typeof values.status === 'string' ? values.status : values.status?.value

    const input = {
      code: values.code?.toUpperCase(),
      name: values.name,
      symbol: values.symbol,
      category: category?.toUpperCase(),
      conversionFactor: values.conversionFactor,
      status,
    }

    await onAdd({ input })
  }

  return { onSubmit }
}
